import React from 'react'
import Slider from '../Slider/Slider'
import Cards from '../Cards/Cards'

export default function Home() {
    return <>
    <Slider />
    <Cards/>
    </>
}
